export const VOICEX_URL_CONSTANTS = {
    "voicex-us": "https://external-proxy-us.nurixlabs.tech",
    "voicex-in": "https://external-proxy.nurixlabs.tech",
    "voicex-stage": "https://agentx.stage.nurixlabs.tech"
};

// ZERO WORKSPACE TENANT USER IDS
export const DEFAULT_TENANT_ID = "93debacb-6338-4fe3-befb-731e7fd94a3b";
export const DEFAULT_WORKSPACE_ID = "93debacb-6338-4fe3-befb-731e7fd94a3b";
export const DEFAULT_USER_ID = "40d323bc-dc17-4b3d-a7ac-8ded8a0b16ff";

// OLD WORKSPACE TENANT USER IDS
export const OLD_TENANT_ID = "68736eb3-1642-49aa-b487-c403acf7d1a5";
export const OLD_WORKSPACE_ID = "5a63f8bf-4ab9-4af8-abfb-f4a7fdf03e6d";
export const OLD_USER_ID = "dc9c7205-6eb0-49eb-9045-b9f9aea396ff";

export const STAGE_TENANT_ID = "71d3b0f4-3320-475e-9458-60badfadf6f0";
export const STAGE_WORKSPACE_ID = "71d3b0f4-3320-475e-9458-60badfadf6f0";
export const STAGE_USER_ID = "4a0de57d-abe9-4041-9393-6ebc7f21c69c";

export const US_TENANT_ID = "be26a7c9-011a-4f55-9866-fe9852ac1500";
export const US_WORKSPACE_ID = "be26a7c9-011a-4f55-9866-fe9852ac1500";
export const US_USER_ID = "38a3aa4e-f93b-4c21-8619-e17854b68f65";

export const NURIX_WORKSPACE_ID = "4321b0d7-361c-4250-97c2-f987f0b72a56"
export const NURIX_TENANT_ID = "4321b0d7-361c-4250-97c2-f987f0b72a56"
